<template>
	<div class="c-main-nav__contact">
		<h2>{{contact.title}}</h2>
		<ul class="c-main-nav__contact-list">
			<li
				v-for="(item, i) in contactArray"
				:key="i"
				class="c-main-nav__contact-item">
				<p>{{item.text}}</p>
				<a v-if="item.action === 'button'" :href="item.actionUrl" class="c-button c-button--ghost c-button--noboxshadow c-button--icon c-main-nav__contact-button">
					<span class="c-button--right">{{item.actionText}}</span>
					<v-icon name="icon-arrow-circle" size="m"></v-icon>
				</a>
				<a v-if="item.action === 'link'" :href="item.actionUrl" class="c-main-nav__contact-phone">{{item.actionText}}</a>
			</li>
		</ul>
		<a :href="contact.readMoreUrl" @blur="closeMenu" class=" c-main-nav__contact-link">{{contact.readMoreText}}</a>
	</div>
</template>

<script>
import VIcon from '../../../components/icon/VIcon.vue';

export default {
	name: 'VMainNavContact',
	components: {
		VIcon
	},
	props: {
		contact: Object
	},
	data() {
		return {
			contactArray: this.contact.blocks.slice(0, 2)
		}
	},
	methods: {
		closeMenu() {
			this.$parent.handleMouseLeave();
		}
	}
}
</script>
